/* eslint-disable react/no-unescaped-entities */
import React from 'react'

const GeneralConditionsPage = () => {
  return (
    <div className='min-h-screen bg-gray-100 p-6 flex flex-col items-center'>
      <section
        id='cgs-voyo'
        style={{
          fontFamily: 'Arial, sans-serif',
          maxWidth: '900px',
          margin: '0 auto',
          padding: '20px',
          lineHeight: '1.6',
          color: '#333',
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <h1
          className='bird'
          style={{
            textAlign: 'center',
            color: '#E94E3D',
            fontSize: '2em',
            marginBottom: '20px',
          }}
        >
          🦜 Conditions Générales de Service (CGS) – Voyo
        </h1>
        <p style={{ textAlign: 'center', fontStyle: 'italic', marginBottom: '30px' }}>
          Bienvenue sur <strong>Voyo</strong> ! Découvrez toutes les règles pour utiliser notre
          plateforme en toute confiance.
        </p>

        {/* 1. Acceptation des Conditions */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🐤 1. Acceptation des Conditions ; Modifications
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Les présentes Conditions Générales de Service (les "Conditions") constituent un accord
          juridique contraignant entre vous et Voyo, une société française. Les Conditions régissent
          votre utilisation de notre site, applications et services en ligne. EN ACCEPTANT CES
          CONDITIONS, VOUS ACCEPTEZ CES CONDITIONS. SI VOUS N'ÊTES PAS D'ACCORD, NE PAS UTILISER LE
          SERVICE. Les modifications seront effectives dès publication ; votre usage continu vaut
          acceptation.
        </p>

        {/* 2. Le Service Voyo */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🦜 2. Le Service Voyo
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Voyo met en relation Mandants et Visiteurs. Nous facilitons la communication et les
          paiements, mais ne réalisons pas directement les visites. Chaque utilisateur est
          responsable de ses décisions et interactions. Voyo n'est pas responsable des actions ou du
          comportement des Visiteurs et Mandants.
        </p>

        {/* 3. Certification et Conformité */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🐦 3. Certification et Conformité
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Vous certifiez respecter la loi applicable et avoir l'âge requis. Les mandants et
          visiteurs doivent se conformer aux obligations légales et fiscales. Voyo se fie à vos
          certifications et n'est pas responsable en cas de manquement.
        </p>

        {/* 4. Utilisation du Service */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🕊 4. Utilisation du Service et Suspension
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Vous vous engagez à utiliser Voyo conformément à la loi et à son objectif. Voyo peut
          suspendre ou résilier un compte en cas de non-respect des CGS ou pour protéger la
          communauté.
        </p>

        {/* 5. Inscription et sécurité du compte */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🦢 5. Inscription et sécurité du compte
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Fournissez des informations exactes et gardez votre compte sécurisé. Vous êtes responsable
          de toute activité sur votre compte.
        </p>

        {/* 6. Confidentialité */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🐥 6. Confidentialité
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Vos informations sont traitées selon notre
          <a href='/politique-confidentialite' style={{ color: '#E94E3D' }}>
            Politique de confidentialité
          </a>
          . Vous acceptez leur utilisation pour le fonctionnement de Voyo.
        </p>

        {/* 7. Contenu des utilisateurs */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🦚 7. Contenu des utilisateurs
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Tout contenu publié reste sous votre responsabilité. Vous accordez à Voyo le droit
          d'utiliser votre contenu dans le cadre du service et de sa promotion. Voyo peut filtrer,
          modifier ou supprimer tout contenu à sa discrétion.
        </p>

        {/* 8. Changement de numéro de téléphone */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🐦 8. Changement de numéro de téléphone
        </h2>
        <p style={{ marginBottom: '20px' }}>
          En cas de changement de numéro, mettez rapidement à jour vos informations de compte pour
          éviter que vos messages soient reçus par quelqu'un d'autre.
        </p>

        {/* 9. Frais et Paiement */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🕊 9. Frais et Paiement
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Les tarifs et paiements sont indiqués sur la plateforme. Mandants et visiteurs concluent
          des transactions entre eux. Voyo facilite le paiement via Stripe et peut retenir des
          montants en cas de suspicion d'activité frauduleuse. La politique d'annulation et de
          remboursement est précisée dans l'espace utilisateur.
        </p>

        {/* 10. Responsabilité et indemnisation */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🦢 10. Responsabilité et indemnisation
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Voyo décline toute responsabilité pour les actions, omissions ou litiges entre
          utilisateurs. Vous vous engagez à indemniser Voyo en cas de réclamation liée à votre usage
          du service.
        </p>

        {/* 11. Limitation de responsabilité */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🐥 11. Limitation de responsabilité
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Dans toute la mesure permise par la loi, Voyo ne sera pas responsable des dommages directs
          ou indirects. La responsabilité maximale est limitée aux montants effectivement payés à
          Voyo au cours des 12 mois précédents l&apos;événement.
        </p>

        {/* 12. Garantie */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🦚 12. Garantie du service Voyo
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Le service est fourni tel quel. Voyo ne garantit pas l&apos;exactitude des informations
          publiées par les utilisateurs, ni la disponibilité continue du service. Les avis et
          conseils de tiers sont sous leur responsabilité.
        </p>

        {/* 13. Force majeure */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🐦 13. Cas de force majeure
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Voyo ne pourra être tenue responsable des retards ou défauts d'exécution dus à des
          circonstances indépendantes de sa volonté, telles que catastrophes naturelles, pandémies
          ou grèves.
        </p>

        {/* 14. Obligations des visiteurs */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🕊 14. Obligations des visiteurs
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Les visiteurs doivent respecter les obligations fiscales et légales dans leur juridiction
          et déclarer clairement leur statut professionnel. Voyo décline toute responsabilité en cas
          de manquement.
        </p>

        {/* 15. Collecte des informations fiscales */}
        <h2 className='bird' style={{ color: '#E1B12C', marginTop: '30px', marginBottom: '15px' }}>
          🦢 15. Collecte des informations fiscales
        </h2>
        <p style={{ marginBottom: '20px' }}>
          Les utilisateurs générant des revenus via Voyo doivent fournir des informations fiscales
          exactes et à jour. Voyo peut suspendre l'accès ou bloquer les paiements si ces
          informations ne sont pas fournies. Vous acceptez que Voyo transmette ces informations aux
          autorités compétentes.
        </p>
      </section>

      <style>{`
        /* Animation oiseaux */
        .bird {
          display: inline-block;
          transform-origin: center bottom;
          transition: transform 0.4s ease;
          animation: fly 4s ease-in-out infinite;
        }

        .bird:hover {
          transform: translateY(-5px) rotate(-5deg);
        }

        @keyframes fly {
          0% { transform: translateY(0px) rotate(0deg); }
          25% { transform: translateY(-3px) rotate(-2deg); }
          50% { transform: translateY(0px) rotate(0deg); }
          75% { transform: translateY(-3px) rotate(2deg); }
          100% { transform: translateY(0px) rotate(0deg); }
        }
      `}</style>
    </div>
  )
}

export default GeneralConditionsPage
